import { Pipe, PipeTransform } from '@angular/core';
import { DayOfWeekEnum } from '@sb/library/data-models';

@Pipe({
    name: 'formatMonthlyToWords'
})
export class LocalizationMonthlyToWordsPipe implements PipeTransform {

    transform(dayOfWeek: DayOfWeekEnum, weekOfMonth: number): string {
        return this.GetTranslatedMonthlyRelativeDay(dayOfWeek, weekOfMonth);
    }

    // Generated by ChatGPT - Brute force each case for proper translation targets
    GetTranslatedMonthlyRelativeDay(dayOfWeek: DayOfWeekEnum, weekOfMonth: number) {
        if (weekOfMonth === 1) {
            switch (dayOfWeek) {
                case DayOfWeekEnum.Monday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFirstMonday:Monthly on the first Monday`;
                case DayOfWeekEnum.Tuesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFirstTuesday:Monthly on the first Tuesday`;
                case DayOfWeekEnum.Wednesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFirstWednesday:Monthly on the first Wednesday`;
                case DayOfWeekEnum.Thursday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFirstThursday:Monthly on the first Thursday`;
                case DayOfWeekEnum.Friday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFirstFriday:Monthly on the first Friday`;
                case DayOfWeekEnum.Saturday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFirstSaturday:Monthly on the first Saturday`;
                case DayOfWeekEnum.Sunday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFirstSunday:Monthly on the first Sunday`;
                default:
                    throw new Error("Invalid day of the week");
            }
        } else if (weekOfMonth === 2) {
            switch (dayOfWeek) {
                case DayOfWeekEnum.Monday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeSecondMonday:Monthly on the second Monday`;
                case DayOfWeekEnum.Tuesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeSecondTuesday:Monthly on the second Tuesday`;
                case DayOfWeekEnum.Wednesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeSecondWednesday:Monthly on the second Wednesday`;
                case DayOfWeekEnum.Thursday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeSecondThursday:Monthly on the second Thursday`;
                case DayOfWeekEnum.Friday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeSecondFriday:Monthly on the second Friday`;
                case DayOfWeekEnum.Saturday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeSecondSaturday:Monthly on the second Saturday`;
                case DayOfWeekEnum.Sunday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeSecondSunday:Monthly on the second Sunday`;
                default:
                    throw new Error("Invalid day of the week");
            }
        } else if (weekOfMonth === 3) {
            switch (dayOfWeek) {
                case DayOfWeekEnum.Monday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeThirdMonday:Monthly on the third Monday`;
                case DayOfWeekEnum.Tuesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeThirdTuesday:Monthly on the third Tuesday`;
                case DayOfWeekEnum.Wednesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeThirdWednesday:Monthly on the third Wednesday`;
                case DayOfWeekEnum.Thursday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeThirdThursday:Monthly on the third Thursday`;
                case DayOfWeekEnum.Friday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeThirdFriday:Monthly on the third Friday`;
                case DayOfWeekEnum.Saturday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeThirdSaturday:Monthly on the third Saturday`;
                case DayOfWeekEnum.Sunday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeThirdSunday:Monthly on the third Sunday`;
                default:
                    throw new Error("Invalid day of the week");
            }
        } else if (weekOfMonth === 4) {
            switch (dayOfWeek) {
                case DayOfWeekEnum.Monday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFourthMonday:Monthly on the fourth Monday`;
                case DayOfWeekEnum.Tuesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFourthTuesday:Monthly on the fourth Tuesday`;
                case DayOfWeekEnum.Wednesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFourthWednesday:Monthly on the fourth Wednesday`;
                case DayOfWeekEnum.Thursday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFourthThursday:Monthly on the fourth Thursday`;
                case DayOfWeekEnum.Friday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFourthFriday:Monthly on the fourth Friday`;
                case DayOfWeekEnum.Saturday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFourthSaturday:Monthly on the fourth Saturday`;
                case DayOfWeekEnum.Sunday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFourthSunday:Monthly on the fourth Sunday`;
                default:
                    throw new Error("Invalid day of the week");
            }
        } else if (weekOfMonth === 5) {
            switch (dayOfWeek) {
                case DayOfWeekEnum.Monday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFifthMonday:Monthly on the fifth Monday`;
                case DayOfWeekEnum.Tuesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFifthTuesday:Monthly on the fifth Tuesday`;
                case DayOfWeekEnum.Wednesday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFifthWednesday:Monthly on the fifth Wednesday`;
                case DayOfWeekEnum.Thursday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFifthThursday:Monthly on the fifth Thursday`;
                case DayOfWeekEnum.Friday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFifthFriday:Monthly on the fifth Friday`;
                case DayOfWeekEnum.Saturday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFifthSaturday:Monthly on the fifth Saturday`;
                case DayOfWeekEnum.Sunday:
                    return $localize`:@@CommonRecurrencePickerMonthlyRelativeFifthSunday:Monthly on the fifth Sunday`;
                default:
                    throw new Error("Invalid day of the week");
            }
        }
        throw new Error("Invalid week of month");
    }

}
